@if (totalRecords > 0) {
<div class="pagination-container">
  <ngb-pagination [collectionSize]="totalRecords" [pageSize]="pageSize" [(page)]="page" [maxSize]="3" [rotate]="true"
    [boundaryLinks]="true" (pageChange)="onPageChange($event)">
  </ngb-pagination>

  <div class="shown-number d-flex align-items-center">
    <span class="me-2">{{ 'GENERAL.PAGE' | translate }} {{ page }} X</span>
    <p-dropdown [options]="pageSizeOptions" [ngModel]="pageSize" appendTo="body"
      (onChange)="onPageSizeChange($event)" />
    <span class="ms-2">{{ 'GENERAL.OF' | translate }} {{ totalRecords }} Items</span>
  </div>
</div>
}
